import { render, staticRenderFns } from "./EditarFormularioModal.vue?vue&type=template&id=648f23b4&scoped=true"
import script from "./EditarFormularioModal.vue?vue&type=script&lang=js"
export * from "./EditarFormularioModal.vue?vue&type=script&lang=js"
import style0 from "./EditarFormularioModal.vue?vue&type=style&index=0&id=648f23b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f23b4",
  null
  
)

export default component.exports